import SelectInput from 'components/input/SelectInput';
import TextInput from 'components/input/textInput';
import React from 'react';
import Grid from '@mui/joy/Grid';

interface Props {
  formik: any;
  disabled?: boolean;
}

const Counselor = (props: Props) => {
  const { disabled = false } = props;
  return (
    <Grid container spacing={2} className="m-0 common-flag">
      <Grid xs={12}>
        <div>CBO Counselor / Advisor / Mentor</div>
      </Grid>
      <Grid xs={12} md={6}>
        <SelectInput
          option={['Dr.', 'Mr.', 'Ms.', 'Mrs.']}
          label="Prefix"
          name="advisor_prefix"
          placeholder="Prefix"
          values={props.formik.values.advisor_prefix}
          onChange={props.formik.handleChange}
          disabled={disabled}
        />
      </Grid>
      <Grid xs={12} md={6}>
        <TextInput
          label="First Name"
          name="advisor_first_name"
          placeholder="First Name"
          values={props.formik.values.advisor_first_name}
          onChange={props.formik.handleChange}
          disabled={disabled}
        />
      </Grid>
      <Grid xs={12} md={6}>
        <TextInput
          label="Last Name"
          placeholder="Last Name"
          name="advisor_last_name"
          onChange={props.formik.handleChange}
          values={props.formik.values.advisor_last_name}
          disabled={disabled}
        />
      </Grid>
      <Grid xs={12} md={6}>
        <TextInput
          label="Phone number"
          type="phoneNumber"
          placeholder="Phone number"
          name="advisor_phone_number"
          onChange={props.formik.handleChange}
          values={props.formik.values.advisor_phone_number}
          disabled={disabled}
        />
      </Grid>
      <Grid xs={12}>
        <TextInput
          label="Email"
          placeholder="Email"
          name="advisor_email"
          onChange={props.formik.handleChange}
          values={props.formik.values.advisor_email}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
};

export default Counselor;
